interface Props {
  score?: number;
  kind: 'momentum' | 'strength';
}

const COLORS: Record<number, string> = {
  5: 'bg-emerald-100 text-emerald-800',
  4: 'bg-green-100 text-green-800',
  3: 'bg-amber-100 text-amber-800',
  2: 'bg-orange-100 text-orange-800',
  1: 'bg-rose-100 text-rose-800',
};

export function ScoreChip({ score, kind }: Props) {
  if (typeof score !== 'number') {
    return <span className="chip bg-slate-100 text-slate-500">—</span>;
  }
  const cls = COLORS[score] ?? 'bg-slate-100 text-slate-600';
  return (
    <span className={`chip ${cls}`}>
      {kind === 'momentum' ? 'Mo' : 'St'} {score}/5
    </span>
  );
}
